/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import * as e from "react";
import { useUnstyled as c, classNames as m, uInput as o } from "@progress/kendo-react-common";
const p = e.forwardRef((t, s) => {
  const a = e.useRef(null), l = e.useRef(null), n = c(), u = n && n.uInput, r = m(
    o.clearButton({
      c: u
    }),
    t.className
  );
  return e.useImperativeHandle(a, () => ({ element: l.current })), e.useImperativeHandle(s, () => a.current), /* @__PURE__ */ e.createElement("span", { ...t, className: r });
});
p.displayName = "KendoReactInputClearValue";
export {
  p as InputClearValue
};
